import styled from "styled-components"

const StyledStepSecond = styled.div`
  .order-data {
    padding-top: 20px;
    .row-group {
      display: flex;
      justify-content: flex-start;
      flex-flow: wrap;
      margin-bottom: 50px;
      margin-left: -40px;
      margin-right: -40px;
      .inp-box {
        flex-basis: calc(33.333% - 80px);
        max-width: calc(33.333% - 80px);
        margin: 0 40px;
        .inp-error {
          top: initial;
          bottom: calc(100% + 8px);
          text-transform: uppercase;
        }
      }
    }
    @media screen and (max-width: 1200px) {
      .row-group {
        margin: 0 auto;
        max-width: 800px;
        .inp-box {
          flex-basis: 100%;
          max-width: 100%;
          margin: 0 0 45px;
        }
      }
    }
  }
`

export default StyledStepSecond
